import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { iconType, notificationType } from "../components/notification/notification.model";

@Injectable({
	providedIn: "root",
})
export class NotificationService {
	isNotificationShow$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	notificationIcon$: BehaviorSubject<iconType> = new BehaviorSubject<iconType>(null);
	notificationType$: BehaviorSubject<notificationType> = new BehaviorSubject<notificationType>(null);
	notificationTitle$: BehaviorSubject<string> = new BehaviorSubject<string>("");
	notificationDescription$: BehaviorSubject<string | string[]> = new BehaviorSubject<string | string[]>("");

	setConfiguration(
		notificationIcon: iconType,
		notificationType: notificationType,
		notificationTitle: string,
		notificationDescription: string | string[]
	) {
		this.notificationIcon$.next(notificationIcon);
		this.notificationType$.next(notificationType);
		this.notificationTitle$.next(notificationTitle);
		this.notificationDescription$.next(notificationDescription);
	}

	showNotification() {
		this.hideNotification();
		this.isNotificationShow$.next(true);
	}

	hideNotification() {
		this.isNotificationShow$.next(false);
	}
}
